// extracted by mini-css-extract-plugin
export default {"container":"empty-player-clips_container__mL0bU","text":"empty-player-clips_text__bUhUe"};